import { useCallback, useRef, useState } from "react";
import { Button, Container, useDisclosure } from "@chakra-ui/react";
import RouterLink from "../../components/RouterLink";
import queryString from "query-string";
import TableList from "../../components/TableList";
import { useLocation, useNavigate } from "react-router-dom";
import { useConfirmation } from "../../contexts/ConfirmationContext";
import CardForm from "../../components/CardForm";
import TableListTitle from "../../components/TableList/TableListTitle";
import TableListPagination from "../../components/TableList/TableListPagination";
import { useQueryParams } from "../../hooks/queryParams";
import {
  PaginatorInfo,
  useListUsersQuery,
  User,
} from "../../generated/graphql";
import Filter from "./Filter";
import TableUser from "../../components/TableUser";
import QuotationForm from "../Quotation/QuotationForm";
import { TableImperativeHandle } from "../../components/DefaultTable";
import { FormMutationType } from "../../components/FullWidthModal/interface";

const UserList: React.FC = () => {
  const location = useLocation();

  const { pathname } = location;

  const { confirmation, setIsLoading, close } = useConfirmation();

  const navigate = useNavigate();

  const [products, setUsers] = useState<User[]>([]);

  const [paginator, setPaginator] = useState<PaginatorInfo>();

  const { queryParams } = useQueryParams<{
    page?: string;
    key?: string;
  }>();

  const { data: dataUsers } = useListUsersQuery();

  const [loading, setLoading] = useState(false);

  const {
    isOpen: isOpenForm,
    onOpen: onOpenForm,
    onClose: onCloseForm,
  } = useDisclosure();

  const [selectedId, setSelectedId] = useState("");

  const callListPromos = useCallback(async () => {
    setLoading(true);

    try {
      // let graphqlParam: any = {
      //   query: listProducts,
      // }
      // if (queryParams) {
      //   graphqlParam.variables = {
      //     ...graphqlParam.variables,
      //     page: parseInt(queryParams.page as string),
      //     filter: {
      //       name: `%${queryParams.key}%`,
      //     },
      //   }
      // }
      // const resListPromos: any = await query(graphqlParam)
      // const promoPromises = resListPromos?.data.listPromos.data.map(
      //   async (item: IPromo) => {
      //     return {
      //       ...item,
      //       image: await getImagePromise(item.image),
      //     }
      //   }
      // )
      //const dataPromos = await Promise.all(promoPromises)
      // setPromos(dataPromos)
      // setPaginator(resListPromos?.data.listPromos.paginatorInfo)
      // setLoading(false)
    } catch (err) {
      console.log("__err", err);
    }
  }, [queryParams]);

  // useEffect(() => {
  //   callListProducts()
  // }, [callListProducts])

  const deleteRow = useCallback(
    async (id: string) => {
      try {
        // await query({
        //   query: deletePromo,
        //   variables: {
        //     id,
        //   },
        // })
        // callListPromos()
      } catch (err) {
        console.log("_error", err);
      } finally {
      }
    },
    [callListPromos]
  );

  const tableRef = useRef<TableImperativeHandle<User>>(null);

  const onPageChange = (page: number) => {
    const url = queryString.stringifyUrl({
      url: pathname,
      query: {
        page,
      },
    });

    navigate(url);
  };

  return (
    <>
      <Container maxW="container.xl">
        <CardForm>
          <TableListTitle
            title="Pengguna"
            actionComponents={
              <Button as={RouterLink} to="/user/invite" size="sm">
                Undang Pengguna
              </Button>
            }
          />
          {products.length > 0 && (
            <TableListPagination
              paginationProps={{
                paginator: paginator as PaginatorInfo,
                onPrev: (value: any) => {
                  if (onPageChange) {
                    onPageChange(value);
                  }
                },
                onNext: (value: any) => {
                  if (onPageChange) {
                    onPageChange(value);
                  }
                },
              }}
              filterComponents={
                <Filter
                  onSubmit={(data) => {
                    const url = queryString.stringifyUrl({
                      url: pathname,
                      query: { ...data, page: 1 },
                    });

                    navigate(url);
                  }}
                  value={queryParams}
                />
              }
            />
          )}

          <TableUser />
        </CardForm>
      </Container>
      <QuotationForm
        isOpen={isOpenForm}
        onClose={(res) => {
          if (res?.type === FormMutationType.UPDATE) {
            //tableRef.current?.updateRow(res.data as User);
          } else if (res?.type === FormMutationType.CREATE) {
            tableRef.current?.refresh();
            onPageChange(1);
          }
          setSelectedId("");
          onCloseForm();
        }}
        id={selectedId}
      />
    </>
  );
};

export default UserList;
